import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";

export interface CustomerExperienceFilters {
  order_type: FilterValue[] | null;
  pm_admin_id: FilterValue[] | null;
  start_date: Dayjs;
  end_date: Dayjs;
}

export interface CustomerExperienceSelectedFilters {
  order_type: FilterValue[] | null;
  pm_admin_id: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export interface CustomerExperienceAPIFilters {
  order_type: FilterValue[] | null;
  pm_admin_id: FilterValue[] | null;
  start_date: string;
  end_date: string;
}

export function parseQueryParamsForCustomerExperienceFilters(
  params: CustomerExperienceFilters | null,
  query_params: URLSearchParams,
): CustomerExperienceFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  return {
    order_type: params?.order_type ?? [],
    pm_admin_id: params?.pm_admin_id ?? [],
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
  };
}
